"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORT_TARGET_TYPE = void 0;
/**
 * @internal
 */
var SORT_TARGET_TYPE;
(function (SORT_TARGET_TYPE) {
    SORT_TARGET_TYPE["ALPHABETICAL_ASC"] = "alphabetical-asc";
    SORT_TARGET_TYPE["ALPHABETICAL_DESC"] = "alphabetical-desc";
    SORT_TARGET_TYPE["NUMERICAL_ASC"] = "numerical-asc";
    SORT_TARGET_TYPE["NUMERICAL_DESC"] = "numerical-desc";
})(SORT_TARGET_TYPE = exports.SORT_TARGET_TYPE || (exports.SORT_TARGET_TYPE = {}));
//# sourceMappingURL=types.js.map